import React from 'react';
import { NavLink } from 'react-router-dom';

import { Search } from './Search';

export const Navigation = () => {
  return (
    <nav className="topnav">
      <div className='logo-bar'>
      <NavLink to="/APIDOCS_V2">PCRecruiter API</NavLink>
      </div>
      <div className='search-bar'>
      <Search projectIds={['cHJqOjE3NDY2OA']} />
      </div>
    </nav>
  );
};
